const initialState = () => {
    return {
        /**
         * @description
         */

        uniqueKey: '',
        permission: '',

    }
}

export default initialState
